import React from "react";
import VectorCropping from "./VectorCropping";
import { connect } from "react-redux";
import {
  isCroppingSelector,
  contextSelector,
  selectedItemsSelector,
  zoomSelector,
  designDataSelector,
  elementPreviewsSelector
} from "state/ui/editorContext/editorContextSelectors";
import { getPath } from "lib/lodash";
import { getPageOffsetInCanvasbackground } from "views/components/Editor/utils";
import { update as updateEditorContextState } from "state/ui/editorContext/editorContextActions";
import { getPageHtmlNode } from "views/components/Editor/utils";
import {
  calculateMovedNewDimensions,
  calculateCropMaskScale
} from "views/components/Editor/CropLayer/ImageCropping/ImageCroppingPreview/ImageCroppingPreviewCalculations";
import { Logger } from "lib";

class VectorCroppingContainer extends React.Component {
  constructor(props) {
    super(props);

    this.getElementWithPreview = this.getElementWithPreview.bind(this);
    this.getPageOffsetInCanvasbackground =
      this.getPageOffsetInCanvasbackground.bind(this);
    this.getElementWithPreview = this.getElementWithPreview.bind(this);
    this.getElementPreview = this.getElementPreview.bind(this);
    this.startCropMaskResize = this.startCropMaskResize.bind(this);
    this.finishCropMaskResize = this.finishCropMaskResize.bind(this);
    this.startVectorCropMoving = this.startVectorCropMoving.bind(this);
    this.finishVectorCropMoving = this.finishVectorCropMoving.bind(this);
  }

  getElementPreview(elementId) {
    if (!elementId) return {};
    const { elementPreviews, selectedItems } = this.props;

    const elementSelection =
      selectedItems.find(item => item.itemId === elementId) || {};

    return {
      ...elementPreviews[elementId],
      ...elementSelection.preview
    };
  }

  getElementWithPreview(elementId) {
    if (!elementId) return {};
    const { designData } = this.props;

    const element = designData.getElement(elementId);

    const elementPreview = this.getElementPreview(elementId);

    // when the preview is image instructions we want to replace without removing unchanged ones
    if (Object.keys(elementPreview).includes("imageInstructions")) {
      const previewInstructions = elementPreview.imageInstructions;
      const elementInstructions = element.imageInstructions;

      const originalInstructionsByDomId = elementInstructions.reduce(
        (combinedInstructions, currentInstruction) => ({
          ...combinedInstructions,
          [currentInstruction.domId]: currentInstruction
        }),
        {}
      );

      previewInstructions.forEach(previewInstruction => {
        originalInstructionsByDomId[previewInstruction.domId] =
          previewInstruction;
      });

      elementPreview.imageInstructions = Object.values(
        originalInstructionsByDomId
      );
    }

    return {
      ...element,
      ...elementPreview
    };
  }

  getPageOffsetInCanvasbackground(pageId) {
    if (!pageId) return 0;
    return getPageOffsetInCanvasbackground(pageId);
  }

  startCropMaskResize() {
    Logger.info("VectorCroppingContainer.startCropMaskResize called");
    this.props.updateContext({
      isCropping: true
    });
  }

  finishCropMaskResize({
    differenceFromInitialOffset,
    dragItem,
    adjustmentOffset
  }) {
    Logger.info("VectorCroppingContainer.finishCropMaskResize called");
    const { zoom, selectedItems } = this.props;
    const selectedVector = getPath(this.props, "selectedItems.0");
    let imageElement = this.getElementWithPreview(selectedVector?.itemId);

    imageElement = {
      ...imageElement
      // angle: 0
    };

    const pageId = selectedVector?.pageId;

    const pageDiv = getPageHtmlNode(pageId);
    const pageOffset = pageDiv.getBoundingClientRect();

    const { mask, height, width, top, left } = calculateCropMaskScale.calc({
      imageElement,
      dragItem,
      differenceFromInitialOffset,
      pageOffset,
      zoom,
      adjustmentOffset
    });

    const selectedItemUpdated = [
      {
        ...selectedItems[0],
        preview: {
          ...selectedItems[0].preview,
          mask,
          height,
          width,
          top,
          left
        }
      }
    ];

    this.props.updateContext({
      isCropping: false,
      selectedItems: selectedItemUpdated
    });
  }

  startVectorCropMoving() {
    Logger.info("VectorCroppingContainer.startVectorCropMoving called");

    this.props.updateContext({
      isCropping: true
    });
  }

  finishVectorCropMoving({ differenceFromInitialOffset }) {
    Logger.info("VectorCroppingContainer.finishVectorCropMoving called");

    const { zoom } = this.props;
    const selectedVector = getPath(this.props, "selectedItems.0");
    let imageElement = this.getElementWithPreview(selectedVector.itemId);

    const { mask } = calculateMovedNewDimensions({
      imageElement,
      differenceFromInitialOffset,
      zoom
    });

    const selectedItemUpdated = [
      {
        ...selectedVector,
        preview: {
          ...selectedVector.preview,
          mask
        }
      }
    ];

    this.props.updateContext({
      isCropping: false,
      selectedItems: selectedItemUpdated
    });
  }

  render() {
    if (
      !this.props.canvasBackground ||
      !this.props.context ||
      !this.props.context.isCroppingVector
    ) {
      return null;
    }

    const selectedVector = getPath(this.props, "selectedItems.0");

    const vectorElement = this.getElementWithPreview(selectedVector?.itemId);

    const pageId = selectedVector?.pageId || "";
    const pageOffset = this.getPageOffsetInCanvasbackground(pageId);

    return (
      <VectorCropping
        {...this.props}
        vectorElement={vectorElement}
        pageId={pageId}
        pageOffset={pageOffset}
        startCropMaskResize={this.startCropMaskResize}
        finishCropMaskResize={this.finishCropMaskResize}
        startVectorCropMoving={this.startVectorCropMoving}
        finishVectorCropMoving={this.finishVectorCropMoving}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isCropping: isCroppingSelector(state),
    context: contextSelector(state),
    selectedItems: selectedItemsSelector(state),
    zoom: zoomSelector(state),
    elementPreviews: elementPreviewsSelector(state),
    designData: designDataSelector(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateContext: args => dispatch(updateEditorContextState(args))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VectorCroppingContainer);
